import autoload from "./autoload";
import auth from "./mixins/auth";
import cart from "./mixins/cart";
import initDom from "./mixins/init_dom";
import CatalystMixingCalculator from './components/CatalystMixingCalculator.vue'

autoload();

window.app = new Vue({
  el: "#vue-catalyst-mixing-calculator",

  mixins: [initDom, auth, cart],

  components: {
    CatalystMixingCalculator
  }
});
